import { useQuery } from 'react-query'
import { useSnackbar } from 'notistack'
import { getCustomerGroups } from 'services/cm-api/get-customer-groups'

/**
 * Loads every customer group, newest first. Mirrors the gating
 * convention used by useCustomers — only runs once the Firebase
 * access token has been stored in localStorage.
 */
export function useCustomerGroups() {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(['getCustomerGroups'], () => getCustomerGroups(), {
    enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
    onError: (err) => {
      enqueueSnackbar('Cannot get customer groups', { variant: 'error' })
      console.error('getCustomerGroups failed: ', err)
    },
  })
}
